import { THYROID_TESTS, INFLAMMATION_TESTS, BLOOD_PANEL_TESTS } from "./constants";

/**
 * Parse test values from form inputs into numeric values for the API.
 * Handles comma-to-dot normalization for European decimal format.
 */
export function parseTestValues(testValues, hasAcuteSymptoms) {
  const tests = {};
  const parse = (group) => {
    group.forEach((test) => {
      const val = testValues[test.key];
      const normalized = val ? val.toString().replace(',', '.') : val;
      tests[test.key] = normalized !== "" && normalized !== undefined ? parseFloat(normalized) : null;
    });
  };
  parse(THYROID_TESTS);
  parse(BLOOD_PANEL_TESTS);
  if (hasAcuteSymptoms) {
    parse(INFLAMMATION_TESTS);
  }
  return tests;
}
